import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  Box,
  ListItemText,
  Typography,
  IconButton,
} from "@mui/material";
//   import Labform from "../../Lab/components/Labform";
import { useContext, useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { useParams } from "react-router-dom";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckIcon from "@mui/icons-material/Check";
import DentalForm from "./DentalForm";
import { TeethContextV1, TeethContextType } from "../../../indexv1";
import { useFormContext } from "react-hook-form";
import { useMutation } from "react-query";
import {
  deleteDentalProceure,
  GetDentalDetailsList,
  GetDentalDetailsListV2,
} from "../../../../../services";
import { DentalRecord, DentalRecords, Procedure, Tooth } from "./Types";
import usePopup from "../../../../../../hooks/usePopup";
import CustomTableBody from "../../../../../../utilis/component/CustomTableBody";
import { EmrContext } from "../../../../../index";
import useAuthentication from "@hooks/useAuthentication";

const DentalTable = () => {
  const { user } = useAuthentication();
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const { setSelectedTooth, selectedTooth, setEdit, edit, saveFlag } =
    useContext(TeethContextV1) as TeethContextType;
  const [show, setShow] = useState<boolean>(false);
  const [tableData, setTableData] = useState<DentalRecords | null>([]);
  const { patientData } = useContext(EmrContext);
  const { reset } = useFormContext();
  useEffect(() => {
    reset(edit);
  }, [edit]);

  useEffect(() => {
    if (Object.keys(edit).length !== 0) {
      setShow(true);
    } else {
      Object.keys(selectedTooth).length > 0 ? setShow(true) : setShow(false);
    }
  }, [selectedTooth, edit]);

  const { mutate: getList, isLoading } = useMutation(
    (id: number) => {
      if (user?.codetype === "CPT") {
        return GetDentalDetailsList(id);
      } else {
        return GetDentalDetailsListV2({
          encounterId: id,
          clinicId: Number(user?.clinicId), // Ensure this is a number
          insname: patientData?.insurancePatient?.insurance_name || "N/A",
        });
      }
    },
    {
      onSuccess: (data) => {
        setTableData(data.response);
      },
      onError: (error) => {
        console.error("Error fetching dental list:", error);
      },
    },
  );
  const { mutate: deleteProcedure } = useMutation(deleteDentalProceure, {
    onSuccess: (data) => {
      if (data.responseIndicator === "success") {
        showSnackbar({
          message: "Procedure Deleted Successfully",
          open: true,
          variant: "success",
        });

        setEdit({});
        setSelectedTooth({});
        getList(parseInt(encounterId as string));
      }
    },
  });
  useEffect(() => {
    getList(parseInt(encounterId as string));
  }, [saveFlag]);

  const handleEdit = (data: Procedure, tooth: Tooth[]) => {
    const hasDiscountAmount =
      data?.discountAmount !== null &&
      data?.discountAmount !== undefined &&
      data?.discountAmount !== "";
    const discountType = hasDiscountAmount ? "Amount" : "Percentage";
    const discountValue = hasDiscountAmount
      ? Number(data?.discountAmount || 0)
      : Number(data?.discountPercentage ?? data?.insDiscount ?? 0);

    const update: any = {
      amount: patientData?.pmaster?.paymentMode
        ? data?.isExclude
          ? data?.amount
          : data?.insAmount || data?.amount
        : data?.amount,
      approvalRequired: data.isApprovalRequired,
      isExcluded: data?.isExclude,
      cpt: data.cptDetails,
      encounterId: data.encounterId,
      IsPerfomed: data.isPerformed,
      nursingProcedure: data.nursingProcedure,
      procedureId: data.procedureId,
      Patientshare: patientData?.pmaster?.paymentMode
        ? data?.isExclude
          ? data?.amount
          : data?.pShare || data?.amount
        : data?.amount,
      patientshare: patientData?.pmaster?.paymentMode
        ? data?.isExclude
          ? data?.amount
          : data?.pShare || data?.amount
        : data?.amount,
      Quantity: data.quantity,
      Rate: data.unitRate,
      Reason: data.reason,
      Remark: data?.remarks || data?.doctorsRemarks || "",
      nursingRemarks: data?.nursingRemarks || "",
      discountType,
      discount: discountValue,
    };
    const aggregatedUpdates: { [key: string]: Tooth } = {};
    tooth.forEach((item) => {
      const key = `teeth${item.toothNo}`;
      aggregatedUpdates[key] = {
        id: item.id,
        toothNo: item.toothNo,
        section: item.section,
        image1: `tooth${item.toothNo}_48`,
        image2: `tooth${item.toothNo}_48C`,
      };
    });
    setSelectedTooth({
      ...aggregatedUpdates,
    });
    setEdit(update);
  };

  const handleDelete = (id: number) => {
    deleteProcedure(id);
  };

  return (
    <div>
      <Paper>
        {/* <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow
                  sx={(theme) => ({
                    backgroundColor: theme.palette.primary.main,
                  })}
                >
                  {heading.map((heading, index) => (
                    <TableCell
                      sx={(theme) => ({ color: theme.palette.background.paper })}
                      align="left"
                      key={`heading${index}`}
                    >
                      {heading}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                    <Collapse in={show} timeout="auto" unmountOnExit>
                      <Box>
                        <DentalForm/>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
                {tableData?.map((item:DentalRecord, index: number) => (
                  <>
                    <TableRow key={index}>
                      <TableCell>
                        <ListItemText
                          primary={`${item.procedure.cptDetails.cptCode}`}
                          secondary={
                            <>
                              <Typography
                                component="span"
                                variant="body2"
                                sx={{ color: "text.primary", display: "inline" }}
                              >
                                {Object.values(item.tooth)[0]?.toothNo>=51?"child":"Adult"}
                               
                              </Typography>
                            </>
                          }
                        ></ListItemText>
                      </TableCell>
  
                      <TableCell>{item.procedure.unitRate}</TableCell>
                      <TableCell>{item.procedure.quantity}</TableCell>
                      <TableCell>{item.procedure.amount}</TableCell>
                      <TableCell>{item.procedure.pShare}</TableCell>
                      <TableCell>
                        {item.procedure.nursingProcedure ? (
                          <CheckIcon color="success" />
                        ) : (
                          <RemoveIcon color="error" />
                        )}
                      </TableCell>
                      <TableCell>
                        {item.procedure.isApprovalRequired? (
                          <CheckIcon color="success" />
                        ) : (
                          <RemoveIcon color="error" />
                        )}
                      </TableCell>
                      <TableCell>
                        {item.procedure.isPerformed ? (
                          <CheckIcon color="success" />
                        ) : (
                          <RemoveIcon color="error" />
                        )}
                      </TableCell>
                      <TableCell>{item.procedure.nursingRemarks}</TableCell>
                      <TableCell>{item.procedure.reason}</TableCell>
                      <TableCell>
                        <IconButton
                            disabled={Object.entries(edit).length!==0}
                            color="primary"
                            onClick={() => {
                              handleEdit(item.procedure,item.tooth);
                            }}
                          >
                            <EditIcon />
                        </IconButton>

                          <IconButton
                              color="error"
                              onClick={() => {
                                handleDelete(item.procedure.procedureId);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                      </TableCell>
                      <TableCell>
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer> */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow
                sx={(theme) => ({
                  backgroundColor: theme.palette.primary.main,
                })}
              >
                {heading.map((heading, index) => (
                  <TableCell
                    sx={(theme) => ({ color: theme.palette.background.paper })}
                    align="left"
                    key={`heading${index}`}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                  <Collapse in={show} timeout="auto" unmountOnExit>
                    <Box>
                      <DentalForm />
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </TableBody>
            <CustomTableBody
              isData={tableData != null ? Boolean(tableData.length > 0) : false}
              dataLoading={isLoading}
              totalSpan={{ row: 5, col: heading.length }}
              alert="No dental procedures found."
            >
              {tableData?.map(
                (item: DentalRecord, index: number) =>
                  Boolean(item.procedure.procedureId) && (
                    <TableRow key={index}>
                      <TableCell>
                        <ListItemText
                          primary={`${item.procedure.cptDetails.cptCode}`}
                          secondary={
                            <>
                              <Typography
                                component="span"
                                variant="body2"
                                sx={{ color: "text.primary", display: "block" }}
                              >
                                {Object.values(item.tooth)[0]?.toothNo >= 51
                                  ? "Child"
                                  : "Adult"}
                              </Typography>

                              {item.procedure.isApprovalRequired && (
                                <Typography
                                  component="span"
                                  sx={{
                                    color: "primary.main",
                                    fontSize: ".7rem",
                                    display: "inline",
                                  }}
                                >
                                  Approval required
                                </Typography>
                              )}
                            </>
                          }
                        />
                      </TableCell>
                      <TableCell>{item.procedure.unitRate}</TableCell>
                      <TableCell>{item.procedure.quantity}</TableCell>
                      <TableCell>
                        {item.procedure.discountAmount && `${item.procedure.discountAmount}`}
                        {item.procedure.discountPercentage &&
                          `${item.procedure.discountPercentage} %`}
                      </TableCell>
                      <TableCell>
                        {Number(
                          patientData?.pmaster?.paymentMode
                            ? item?.procedure.isExclude
                              ? item?.procedure?.amount
                              : item?.procedure?.insAmount ||
                                item?.procedure?.amount
                            : item?.procedure?.amount,
                        ).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {Number(item?.procedure?.pShare || 0).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {item.procedure.nursingProcedure ? (
                          <CheckIcon color="success" />
                        ) : (
                          <RemoveIcon color="error" />
                        )}
                      </TableCell>
                      <TableCell>
                        {item.procedure.isApprovalRequired ? (
                          <CheckIcon color="success" />
                        ) : (
                          <RemoveIcon color="error" />
                        )}
                      </TableCell>
                      <TableCell>
                        {item.procedure.isPerformed ? (
                          <CheckIcon color="success" />
                        ) : (
                          <RemoveIcon color="error" />
                        )}
                      </TableCell>
                      <TableCell>{item.procedure.nursingRemarks}</TableCell>
                      <TableCell>
                        {item.procedure.remarks ||
                          item.procedure.doctorsRemarks}
                      </TableCell>
                      <TableCell>{item.procedure.reason}</TableCell>
                      <TableCell>
                        <IconButton
                          disabled={Object.entries(edit).length !== 0}
                          color="primary"
                          onClick={() => {
                            handleEdit(item.procedure, item.tooth);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => {
                            handleDelete(item.procedure.procedureId);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  ),
              )}
            </CustomTableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

const heading = [
  "Item",
  "Unit Rate",
  "Quantity",
  "Discount",
  "Amount",
  "PatientShare",
  "Nursing Procedure",
  "Approval required",
  "Already performed",
  "Nursing remark",
  "Remark",
  "Reason",
  "Options",
];
export default DentalTable;
